(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fullscreen-menu"] && !Shopify.designMode) return;
  try {
    class FullscreenMenu extends MenuDrawer {
    constructor() {
      super();

      this.setClasses({
        open: 'fullscreen-menu--open',
        opening: 'fullscreen-menu--opening',
        closing: 'fullscreen-menu--closing',
      });

      // Move the panel to the very end of <body>. This guarantees it always
      // paints above everything else (announcement bar, sticky header, etc.)
      // regardless of any z-index/stacking-context quirks in its original
      // ancestors, since it no longer has any of those ancestors.
      this.panel = this.querySelector('.fullscreen-menu');

      this.links = Array.from(this.querySelectorAll('.fullscreen-menu__link'));
      this.mediaItems = Array.from(this.querySelectorAll('.fullscreen-menu__media-item'));

      if (this.panel) {
        document.body.appendChild(this.panel);
      }

      this.links.forEach((link) => {
        link.addEventListener('mouseenter', this.onLinkHover.bind(this, link));
        link.addEventListener('focus', this.onLinkHover.bind(this, link));
      });

      // The panel is no longer a descendant of <details>, so listen for ESC
      // at the document level instead of relying on the base MenuDrawer's
      // `this`-scoped keyup listener (the panel is outside `this` now).
      document.addEventListener('keyup', this.onFullscreenKeyUp.bind(this));

      if (this.panel) {
        this.panel.addEventListener('focusout', this.onFocusOut.bind(this));

        // The close button lives inside the (now relocated) panel, so its
        // bubbling 'drawer:force-close' event no longer passes through
        // `this` (<fullscreen-menu>) on its way up. Listen on the panel too.
        this.panel.addEventListener('drawer:force-close', (event) => {
          event.stopPropagation();
          this.closeMenuDrawer(event);
        });
      }
    }

    onFullscreenKeyUp(event) {
      const charCode = event.code ? event.code.toUpperCase() : event.key.toUpperCase();
      if (charCode !== 'ESCAPE') return;
      if (!this.mainDetailsToggle.hasAttribute('open')) return;
      this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'));
    }

    onFocusOut() {
      setTimeout(() => {
        const activeElement = document.activeElement;
        const stillInside = (this.panel && this.panel.contains(activeElement)) || this.contains(activeElement);
        if (this.mainDetailsToggle.hasAttribute('open') && !stillInside) this.closeMenuDrawer();
      });
    }

    onBodyClick(event) {
      const inside = (this.panel && this.panel.contains(event.target)) || this.contains(event.target);
      if (!inside) this.closeMenuDrawer(event);
    }

    openMenuDrawer(summaryElement = false) {
      setScrollbarWidth();

      if (summaryElement) {
        summaryElement.setAttribute('aria-expanded', true);
        if (this.panel) trapFocus(this.panel, summaryElement);
      }

      setTimeout(() => {
        this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
        document.body.addEventListener('click', this.onBodyClickEvent);
      });
      document.body.classList.add(this.classes.opening);
      document.body.classList.add('overflow-hidden');

      this.openAnimation();
      setTimeout(() => {
        this.mainDetailsToggle.setAttribute('open', '');
        setTimeout(() => {
          this.mainDetailsToggle.classList.add('menu-opening');
          if (this.panel) this.panel.classList.add('fullscreen-menu--is-open');
        }, 10);
      });
    }

    closeMenuDrawer(event, elementToFocus = false) {
      if (event === undefined) return;

      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.classList.add('menu-closing');
      if (this.panel) this.panel.classList.remove('fullscreen-menu--is-open');
      removeTrapFocus(elementToFocus);

      document.body.removeEventListener('click', this.onBodyClickEvent);
      document.body.classList.remove(this.classes.open);
      document.body.classList.add(this.classes.closing);
      document.body.classList.remove('overflow-hidden');

      this.closeAnimation(this.mainDetailsToggle);
      this.dispatchEvent(new CustomEvent('close'));
      document.dispatchEvent(new CustomEvent('menudrawer:close'));
    }

    onLinkHover(link) {
      const title = link.dataset.menuTitle;

      this.links.forEach((item) => item.closest('li').classList.remove('is-active'));
      link.closest('li').classList.add('is-active');

      if (!this.mediaItems.length) return;

      const match = this.mediaItems.find((item) => item.dataset.menuTitle === title);
      this.mediaItems.forEach((item) => item.classList.remove('is-active'));
      (match || this.mediaItems[0]).classList.add('is-active');
    }
  }
  customElements.define('fullscreen-menu', FullscreenMenu);
  } catch(e) { console.error(e); }
})();

})();
